/* eslint-disable @typescript-eslint/no-inferrable-types */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { AppFacadeService } from '../../../services/app-facade.service';
@Component({
    standalone: false,
    selector: 'por-app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent implements OnInit {
    readonly appFacadeService = inject(AppFacadeService);
    private readonly cdn = inject(ChangeDetectorRef);

    ngOnInit(): void {
        this.appFacadeService.getLoader().subscribe(() => {
            this.cdn.detectChanges();
        });
    }
}
